import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_icon_watch = _resolveComponent("b-icon-watch")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_icon_file_text = _resolveComponent("b-icon-file-text")!
  const _component_b_icon_map = _resolveComponent("b-icon-map")!
  const _component_b_icon_image = _resolveComponent("b-icon-image")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_icon_watch)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.unixtodate(_ctx.post.datetime)), 1)
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_icon_file_text)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, { style: {"white-space":"pre-wrap"} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.post.text), 1)
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      (_ctx.post.lat && _ctx.post.lon)
        ? (_openBlock(), _createBlock(_component_b_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, { sm: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_icon_map)
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Lat: " + _toDisplayString(_ctx.post.lat) + " Lon:" + _toDisplayString(_ctx.post.lon), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.post.location), 1)
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.post.lat && _ctx.post.lon)
        ? (_openBlock(), _createBlock(_component_b_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, { sm: "1" }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("iframe", {
                    height: "100px",
                    width: "100%",
                    frameborder: "0",
                    style: {"border":"0"},
                    src: `https://www.google.com/maps/embed/v1/place?key=${_ctx.maps_key}&zoom=15&q=${_ctx.post.lat},${_ctx.post.lon}`
                  }, "\n        ", 8, _hoisted_1)
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_icon_image)
            ], undefined, true),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.images, (image, index) => {
            return (_openBlock(), _createBlock(_component_b_col, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: _ctx.addEndpoint(image),
                    style: {"max-height":"200px","object-fit":"cover"}
                  }, null, 8, _hoisted_2)
                ])
              ], undefined, true),
              _: 2
            }, 1024))
          }), 128))
        ], undefined, true),
        _: 1
      }),
      _hoisted_3
    ], undefined, true),
    _: 1
  }))
}